export default __webpack_public_path__ + "static/media/band.1d78ee86.svg";